import React from 'react';
import { OptionProps } from 'react-select';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { OptionWrapper } from '../../../../../../CommonComponents/OPL/Select/BaseSelect/components/Option';
import { OrionModelOptionDTO } from '../../../api/useOrionModelOptionsQuery';
import { RiskScoreBadge } from '../../RiskScoreBadge/RiskScoreBadge';

interface Props extends OptionProps<OrionModelOptionDTO, false> {
  data: OrionModelOptionDTO;
}

export const Option: React.FC<Props> = ({ innerProps, isFocused, innerRef, data }) => {
  const { name, riskScore } = data;

  return (
    <OptionWrapper
      width="100%"
      height="32px"
      alignItems="center"
      isFocused={isFocused}
      ref={innerRef}
      px="16"
      py="8"
      my="4"
      {...innerProps}
    >
      <Box flex={1}>
        <Text fontWeight={500} mr="8">
          {name}
        </Text>
      </Box>

      <RiskScoreBadge riskScore={riskScore} />
    </OptionWrapper>
  );
};
